module.exports = __webpack_public_path__ + "img/logo-bookmark-white.6f52b7e3.svg";